import React from 'react'
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Col } from 'react-flexbox-grid';

import TextBlock from './TextBlock';
import ImgBlock from './ImgBlock';
import QuoteBlock from './QuoteBlock';
import LinksBlock from './LinksBlock';
import IMessageBlock from './iMessageBlock';
import RatingsBlock from './RatingsBlock';
import IntroImage from './IntroImage';
import ChartBlock from './ChartBlock';
import CompareBlock from './CompareBlock';
import BottomNav from './BottomNavBlock';

import IntroSection from 'pages/june-5/components/intro-section'
import {Spacer} from 'layout/util'
import Head from 'layout/head'
import SocialMediaButtons from 'components/interactive/socialMedia/SocialMediaButtons'
import PageCredits from './PageCredits'

import NoteContainer from "components/interactive/votePref/NoteContainer"

class PropositionPage extends React.Component {

  //-- Grabs the pageId from data.js
  //-- Grabs userId from the URL or the user that's logged in
  getUserAndPageInfo = () => {
  	const { match, user } = this.props;
  	// if (match.params.pageId !== data.pageId) {console.warn("`pageId` from URL (/election/:pageId/:userId) and `pageId` from data file (data.js) do not match.");}
    const pageId = match.params.pageId;
    const authorUserId = match.params.userId;
    // TODO: better verify this as an actual userId
    const loggedInUserId = (user ? user.userId : undefined);
    return { pageId, authorUserId, loggedInUserId };
  }


  //-- dispatches an action to fetch information
  fetchData = () => {
    const { store } = this.context;
    const { pageId, authorUserId, loggedInUserId } = this.getUserAndPageInfo();

    //-- if has have a authorUserId || loggedInUserId
    if (authorUserId || loggedInUserId) {
	    store.dispatch({
	      type: "GET_VOTE_PREF_REQUESTED",
	      payload: {
	        pageId: pageId,
	        userId: (authorUserId || loggedInUserId),
	      }
	    });
	    store.dispatch({
	      type: "LIST_ANNOTATIONS_REQUESTED",
	      payload: {
	        pageId: pageId,
	        userId: (authorUserId || loggedInUserId),
	      }
	    });
    }
  }

  componentWillMount() {
    this.fetchData();
  }


  //-- if user has changed, update data
  componentWillReceiveProps(nextProps){
    const newUser = nextProps.match.params.userId !== this.props.match.params.userId;
    const newPage = nextProps.match.params.pageId !== this.props.match.params.pageId;
    if (newUser || newPage) {
      this.fetchData(nextProps);
    }
  }

  // changeAnnotationVisibility = (value) => {
  //   const { store } = this.context;
  //   store.dispatch({
  //     type: "SET_ANNOTATION_VISIBILITY",
  //     payload: {
  //       visible: value,
  //     }
  //   });
  // }

  render() {
  	const { pageId, authorUserId, loggedInUserId } = this.getUserAndPageInfo();
		const { meta, intro, sections, ratings } = this.props.data;
		const annoVisibility = this.props.annotationVisibility.visible;
		//-- if landing on a page with an author (that's not you) and annotation visibility is false and you haven't already dismissed,
		// if (authorUserId && (authorUserId !== loggedInUserId) && !annoVisibility ) {
		// 	this.changeAnnotationVisibility(true);
		// }
		//-- iterate through sections in data.js and make appropriate data structures
		const bodySections = sections.map( (section,i) => {
			const {type, data, id} = section;
			const annoData = {
				showAnnos: annoVisibility,
				pageId: pageId,
				authorUserId: authorUserId,
				loggedInUserId: loggedInUserId,
				sectionId: id,
			}
			switch(type) {
				case "text-block":
					return (<TextBlock key={i} data={data} annoData={annoData}/>);
				case "img-block":
					return (<ImgBlock key={i} data={data} annoData={annoData}/>);
				case "quote-block":
					return (<QuoteBlock key={i} data={data} />);
				case "iMessage-block":
					return (<IMessageBlock key={i} data={data} annoData={annoData}/>);
				case "links-block":
					return (<LinksBlock key={i} data={data} />);
				case "chart-block":
					return (<ChartBlock key={i} data={data} />);
				case "compare-block":
					return (<CompareBlock key={i} data={data} />);
				case "bottom-nav":
					return (<BottomNav key={i} data={data} color={intro.color}/>);
				default:
					return null;
			}
		});

		const {canonicalUrl, documentTitle, socialHeadline, socialDescription, socialImage} = meta;
		return(
      <div>
        <Head
          url={canonicalUrl}
          title={documentTitle}
          headline={socialHeadline}
          description={socialDescription}
          image={socialImage}
        />

        <IntroSection
          title={intro.title}
          subtitle={intro.subtitle}
          showLocationChange
        />
        <Spacer height={30}/>
        <IntroImage
          img={intro.img}
          color={intro.color}
        />
        <Spacer height={50}/>
        <Row>
          <Col
            xsOffset={0} xs={12}
            smOffset={2} sm={8}
            mdOffset={0} md={3}
            lgOffset={0} lg={3}
          >
            <RatingsBlock
              data={ratings}
              showAnnos={annoVisibility}
            />
          </Col>
          <NoteContainer
            pageId={pageId}
            loggedInUserId={loggedInUserId}
            authorUserId={authorUserId}
            showAnnotations={annoVisibility}
          />
        </Row>
        {bodySections}
        <PageCredits attributions="Yvonne Leow, Jimmy Chion, Jeremy Mann"/>
        <SocialMediaButtons/>
        <Spacer height={70}/>
      </div>

		)
	}
}

PropositionPage.contextTypes = {
  store: PropTypes.object
};

function mapStateToProps(state) {
  // if no user logged in state.user.data isn't here
  const user = state.user ? state.user.data : {};
	const annotationVisibility  = state.annotationVisibility;
  return { user, annotationVisibility };
}

export default connect(mapStateToProps, {})(withRouter(PropositionPage));



// WEBPACK FOOTER //
// ./src/pages/june-5/props/components/PropPage.js